enum PermissionCode {
  CAREERS_CREATE = 'CareersCreate',
  CAREERS_DELETE = 'CareersDelete',
  CAREERS_SEARCH = 'CareersSearch',
  CAREERS_UPDATE = 'CareersUpdate',
  CAREERS_VIEW = 'CareersView',
  CERTIFICATES_CREATE = 'CertificatesCreate',
  CERTIFICATES_DELETE = 'CertificatesDelete',
  CERTIFICATES_SEARCH = 'CertificatesSearch',
  CERTIFICATES_UPDATE = 'CertificatesUpdate',
  CERTIFICATES_VIEW = 'CertificatesView',
  CLUBS_CREATE = 'ClubsCreate',
  CLUBS_CREATE_MEMBER = 'ClubsCreateMember',
  CLUBS_CREATE_PARTNER = 'ClubsCreatePartner',
  CLUBS_DELETE = 'ClubsDelete',
  CLUBS_DELETE_MEMBER = 'ClubsDeleteMember',
  CLUBS_DELETE_PARTNER = 'ClubsDeletePartner',
  CLUBS_INVITE = 'ClubsInvite',
  CLUBS_UPDATE = 'ClubsUpdate',
  CLUBS_UPDATE_MEMBER = 'ClubsUpdateMember',
  CLUBS_UPDATE_PARTNER = 'ClubsUpdatePartner',
  CLUBS_SEARCH = 'ClubsSearch',
  CLUBS_VIEW = 'ClubsView',
  CONTACTS_UPDATE = 'ContactsUpdate',
  ENTERPRISES_CREATE = 'EnterprisesCreate',
  ENTERPRISES_DELETE = 'EnterprisesDelete',
  ENTERPRISES_SEARCH = 'EnterprisesSearch',
  ENTERPRISES_UPDATE = 'EnterprisesUpdate',
  ENTERPRISES_VIEW = 'EnterprisesView',
  EXECUTIVE_COMMITTEES_CREATE = 'ExecutiveCommitteesCreate',
  EXECUTIVE_COMMITTEES_DELETE = 'ExecutiveCommitteesDelete',
  EXECUTIVE_COMMITTEES_SEARCH = 'ExecutiveCommitteesSearch',
  EXECUTIVE_COMMITTEES_UPDATE = 'ExecutiveCommitteesUpdate',
  EXECUTIVE_COMMITTEES_VIEW = 'ExecutiveCommitteesView',
  FEES_CREATE = 'FeesCreate',
  FEES_DELETE = 'FeesDelete',
  FEES_SEARCH = 'FeesSearch',
  FEES_UPDATE = 'FeesUpdate',
  FEES_VIEW = 'FeesView',
  FIELDS_CREATE = 'FieldsCreate',
  FIELDS_DELETE = 'FieldsDelete',
  FIELDS_SEARCH = 'FieldsSearch',
  FIELDS_UPDATE = 'FieldsUpdate',
  FIELDS_VIEW = 'FieldsView',
  MARKETS_CREATE = 'MarketsCreate',
  MARKETS_DELETE = 'MarketsDelete',
  MARKETS_SEARCH = 'MarketsSearch',
  MARKETS_UPDATE = 'MarketsUpdate',
  MARKETS_VIEW = 'MarketsView',
  MEDIAS_CREATE = 'MediasCreate',
  MEDIAS_DELETE = 'MediasDelete',
  MEMBERS_CREATE = 'MembersCreate',
  MEMBERS_DELETE = 'MembersDelete',
  MEMBERS_SEARCH = 'MembersSearch',
  MEMBERS_VIEW = 'MembersView',
  MEMBERS_UPDATE = 'MembersUpdate',
  NOTIFICATIONS_CREATE = 'NotificationsCreate',
  NOTIFICATIONS_DELETE = 'NotificationsDelete',
  NOTIFICATIONS_SEARCH = 'NotificationsSearch',
  NOTIFICATIONS_UPDATE = 'NotificationsUpdate',
  NOTIFICATIONS_VIEW = 'NotificationsView',
  ORGANIZATIONS_CREATE = 'OrganizationsCreate',
  ORGANIZATIONS_DELETE = 'OrganizationsDelete',
  ORGANIZATIONS_SEARCH = 'OrganizationsSearch',
  ORGANIZATIONS_UPDATE = 'OrganizationsUpdate',
  ORGANIZATIONS_VIEW = 'OrganizationsView',
  PARTNERS_CREATE = 'PartnersCreate',
  PARTNERS_DELETE = 'PartnersDelete',
  PARTNERS_SEARCH = 'PartnersSearch',
  PARTNERS_VIEW = 'PartnersView',
  PARTNERS_UPDATE = 'PartnersUpdate',
  RANKS_SEARCH = 'RanksSearch',
  RANKS_UPDATE = 'RanksUpdate',
  RANKS_VIEW = 'RanksView',
  ROLES_CREATE = 'RolesCreate',
  ROLES_DELETE = 'RolesDelete',
  ROLES_EXPORT = 'RolesExport',
  ROLES_SEARCH = 'RolesSearch',
  ROLES_UPDATE = 'RolesUpdate',
  ROLES_VIEW = 'RolesView',
  SCHEDULES_CANCEL = 'SchedulesCancel',
  SCHEDULES_CREATE = 'SchedulesCreate',
  SCHEDULES_DELETE = 'SchedulesDelete',
  SCHEDULES_SEARCH = 'SchedulesSearch',
  SCHEDULES_UPDATE = 'SchedulesUpdate',
  SCHEDULES_VIEW = 'SchedulesView',
  SPONSORS_CREATE = 'SponsorsCreate',
  SPONSORS_DELETE = 'SponsorsDelete',
  SPONSORS_SEARCH = 'SponsorsSearch',
  SPONSORS_UPDATE = 'SponsorsUpdate',
  SPONSORS_VIEW = 'SponsorsView',
  TARGET_CUSTOMERS_CREATE = 'TargetCustomersCreate',
  TARGET_CUSTOMERS_DELETE = 'TargetCustomersDelete',
  TARGET_CUSTOMERS_SEARCH = 'TargetCustomersSearch',
  TARGET_CUSTOMERS_UPDATE = 'TargetCustomersUpdate',
  TARGET_CUSTOMERS_VIEW = 'TargetCustomersView',
  USERS_CREATE = 'UsersCreate',
  USERS_DELETE = 'UsersDelete',
  USERS_EXPORT = 'UsersExport',
  USERS_SEARCH = 'UsersSearch',
  USERS_UPDATE = 'UsersUpdate',
  USERS_VIEW = 'UsersView',
  REPRESENTS_CREATE = 'RepresentsCreate',
  REPRESENTS_DELETE = 'RepresentsDelete',
  REPRESENTS_SEARCH = 'RepresentsSearch',
  REPRESENTS_UPDATE = 'RepresentsUpdate',
  REPRESENTS_VIEW = 'RepresentsView',

  ACTIVITIES_CREATE = 'ActivitiesCreate',
  ACTIVITIES_DELETE = 'ActivitiesDelete',
  ACTIVITIES_SEARCH = 'ActivitiesSearch',
  ACTIVITIES_UPDATE = 'ActivitiesUpdate',
  ACTIVITIES_VIEW = 'ActivitiesView',

  ACTIVITIES_VIEW_FORM = 'ActivitiesViewForm',

  FEEDBACKS_SEARCH = 'FeedbacksSearch',
  FEEDBACKS_VIEW = 'FeedbacksView',
  FEEDBACKS_REPLY = 'FeedbacksReply',
  FEEDBACKS_VIEW_DETAIL_PAGE = 'FeedbacksViewDetailPage',

  NEWS_CREATE = 'DocumentsCreate',
  NEWS_DELETE = 'DocumentsDelete',
  NEWS_SEARCH = 'DocumentsSearch',
  NEWS_UPDATE = 'DocumentsUpdate',
  NEWS_VIEW = 'DocumentsView',

  RANKS_CREATE = 'RanksCreate',
  RANKS_DELETE = 'RanksDelete',

  MEMBER_MODIFICATION_SEARCH = 'MemberModificationsSearch',
  MEMBER_MODIFICATION_VIEW = 'MemberModificationsView',
  MEMBER_MODIFICATION_CONFIRM = 'MemberModificationsConfirm',

  DirectoriesCreate = 'DirectoriesCreate',
  DirectoriesDelete = 'DirectoriesDelete',
  DirectoriesUpdate = 'DirectoriesUpdate',
  MediasUpdate = 'MediasUpdate',
  DirectoriesView = 'DirectoriesView',
}

export default PermissionCode;
